import { render, staticRenderFns } from "./diagnose-history-simple.vue?vue&type=template&id=21c4f1bd&"
import script from "./diagnose-history-simple.vue?vue&type=script&lang=js&"
export * from "./diagnose-history-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "diagnose-history-simple.vue"
export default component.exports